import { render, staticRenderFns } from "./HomeFooter.vue?vue&type=template&id=03c68a01&lang=pug&"
import script from "./HomeFooter.vue?vue&type=script&lang=js&"
export * from "./HomeFooter.vue?vue&type=script&lang=js&"
import style0 from "./HomeFooter.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/build/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('03c68a01')) {
      api.createRecord('03c68a01', component.options)
    } else {
      api.reload('03c68a01', component.options)
    }
    module.hot.accept("./HomeFooter.vue?vue&type=template&id=03c68a01&lang=pug&", function () {
      api.rerender('03c68a01', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/domains/home/HomeFooter.vue"
export default component.exports